"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSetMetadataWithList = updateSetMetadataWithList;
function updateSetMetadataWithList(metadataList) {
    return (setMetadata) => {
        for (const item of metadataList) {
            setMetadata.add(item);
        }
        return setMetadata;
    };
}
//# sourceMappingURL=updateSetMetadataWithList.js.map